// extracted by mini-css-extract-plugin
export default {"FXPairs":"FXPairsList_FXPairs__x7O43","message":"FXPairsList_message__AKyyn"};